/**
 * @internal
 * Internal reference for the render function
 */
export const SLOT_RENDER_FUNCTION_SYMBOL = Symbol('fui.slotRenderFunction');
